import { identityPredicate } from "@p0security/shared/assessment/dsl";
import { identityReducers } from "@p0security/shared/assessment/reducers/identity";

import { identityColumns } from "./columns";

export const identityData = {
  predicate: identityPredicate,
  reducers: identityReducers,
  columns: identityColumns,
};
